export const API = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

export function Badge({ value }) {
  const colors = {
    active: '#10b981', scheduled: '#3b82f6', expiring_soon: '#f59e0b',
    expired: '#ef4444', cancelled: '#6b7280',
    grant: '#10b981', remove: '#ef4444',
    view: '#3b82f6', write: '#8b5cf6', edit: '#f59e0b', action: '#06b6d4',
    sensitive_read: '#ef4444', export: '#10b981',
    company: '#3b82f6', department: '#8b5cf6', module: '#f59e0b', submodule: '#06b6d4', user: '#ec4899',
  };
  const c = colors[value] || '#6b7280';
  return (
    <span style={{ display: 'inline-block', padding: '2px 10px', borderRadius: 12, fontSize: 11, fontWeight: 600, background: c + '18', color: c }}>
      {(value || '').replace(/_/g, ' ')}
    </span>
  );
}

export const tableStyle = { width: '100%', borderCollapse: 'collapse', fontSize: 13 };
export const thStyle = { textAlign: 'left', padding: '10px 12px', borderBottom: '2px solid #e5e7eb', fontSize: 12, fontWeight: 600, color: '#6b7280', whiteSpace: 'nowrap' };
export const tdStyle = { padding: '10px 12px', borderBottom: '1px solid #f3f4f6', color: '#374151', whiteSpace: 'nowrap' };
export const inputStyle = { padding: '7px 10px', borderRadius: 6, border: '1px solid #d1d5db', fontSize: 13, width: '100%', boxSizing: 'border-box' };
export const btnPrimary = { padding: '8px 16px', borderRadius: 6, border: 'none', background: '#3b82f6', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer' };
export const btnSecondary = { padding: '8px 16px', borderRadius: 6, border: '1px solid #d1d5db', background: '#fff', color: '#374151', fontSize: 13, fontWeight: 600, cursor: 'pointer' };
export const btnDanger = { padding: '8px 16px', borderRadius: 6, border: 'none', background: '#ef4444', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer' };
export const btnSmall = { padding: '5px 10px', borderRadius: 6, border: '1px solid #d1d5db', background: '#fff', color: '#374151', fontSize: 12, fontWeight: 600, cursor: 'pointer' };

export const overlayStyle = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 };
export const modalStyle = { background: '#fff', borderRadius: 12, padding: 24, width: 560, maxHeight: '85vh', overflowY: 'auto', fontSize: 13 };

export function FormRow({ label, children }) {
  return (
    <div style={{ marginBottom: 12 }}>
      <div style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>{label}</div>
      {children}
    </div>
  );
}

export function DetailField({ label, value }) {
  return (
    <div style={{ marginBottom: 10 }}>
      <div style={{ fontSize: 11, fontWeight: 600, color: '#9ca3af', textTransform: 'uppercase', marginBottom: 2 }}>{label}</div>
      <div style={{ fontSize: 14, color: '#1a1a2e' }}>{value ?? '—'}</div>
    </div>
  );
}

export function SummaryCard({ label, value, color }) {
  return (
    <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: '16px 18px', borderLeft: `4px solid ${color}` }}>
      <div style={{ fontSize: 12, color: '#6b7280', fontWeight: 500, marginBottom: 6 }}>{label}</div>
      <div style={{ fontSize: 20, fontWeight: 700, color: '#1a1a2e' }}>{value}</div>
    </div>
  );
}

export function StateCard({ label, count, color, icon }) {
  return (
    <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: 16, textAlign: 'center' }}>
      <div style={{ fontSize: 24, marginBottom: 4 }}>{icon}</div>
      <div style={{ fontSize: 26, fontWeight: 700, color }}>{count || 0}</div>
      <div style={{ fontSize: 12, fontWeight: 500, color: '#6b7280' }}>{label}</div>
    </div>
  );
}
